import script from "./mark-down-content.vue?vue&type=script&setup=true&lang=js"
export * from "./mark-down-content.vue?vue&type=script&setup=true&lang=js"

import "./mark-down-content.vue?vue&type=style&index=0&id=73620824&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73620824"]])

export default __exports__